import { Cookies } from 'react-cookie';

const DEFAULT_EXPIRY_IN_SECONDS = 28800; //8 hrs
const COOKIES = {
    ELITE_PARTYZ: 'elitepartyz',
    USER_DETAILS: 'userDetails',
    BUSINESS_DETAILS: 'businessDetails'
};
const SESSION_STORAGE = {
    EVENTS: 'events',
    PRODUCTS: 'products',
    P_METHODS: 'p-info'
};

export const getContestApiHost = () => {
    const environment = process.env.REACT_APP_ENV? process.env.REACT_APP_ENV.toUpperCase(): 'test';
    const apiHost = process.env.NODE_ENV === 'development' ? '/contest' : process.env['REACT_APP_CONTEST_'+environment+'_API_HOST']
    return apiHost
}

export const getApiHost = () => {
    const environment = process.env.REACT_APP_ENV? process.env.REACT_APP_ENV.toUpperCase(): 'test';
    const apiHost = process.env.NODE_ENV==='development'? '/gateway' : process.env['REACT_APP_'+environment+'_API_HOST'];
    return apiHost;
};

export const getMapApi = () => {
    const apiurl = "https://maps.googleapis.com/maps/api/js?key="+process.env.REACT_APP_MAP_API_KEY+"&v=3.exp&libraries=geometry,drawing,places"
    return apiurl
}

export const getResponseError = (response) => {
    let errorMessage = null;
    if(!response || response.status  === 500){
        errorMessage = 'Something went wrong';
    }
    else if(response.success === 'false') {
        errorMessage = response.error? response.error: 'Something went wrong';
    }
    return errorMessage;
};

export const readCookie = (name) => {
    return new Cookies().get(name);
};

export const writeCookie = (name, value) => {
    new Cookies().set(name, value, {
        path: '/',
        secure: false,
        expires: new Date(Date.now() + DEFAULT_EXPIRY_IN_SECONDS * 1000)
    });
};

export const clearCookie = (name) => {
    new Cookies().remove(name, { path: '/' });
};

export const setAuthCookie = (token) => {
    writeCookie(COOKIES.ELITE_PARTYZ, token);
};

export const getAuthCookie = () => readCookie(COOKIES.ELITE_PARTYZ) || {};

export const isLoggedIn = () => {
    const authToken = getAuthCookie();
    const user = getUserDetailsCookie();
    if(authToken.access_token && user.isVerify){
        return true;
    }
    return false;
}

export const clearAuthCookie = () => {
    clearCookie(COOKIES.ELITE_PARTYZ);
};

export const setUserDetailsCookie = (user) => {
    writeCookie(COOKIES.USER_DETAILS, user);
};

export const getUserDetailsCookie = () => readCookie(COOKIES.USER_DETAILS) || {};


export const clearUserDetailsCookie = () => {
    clearCookie(COOKIES.USER_DETAILS);
};

export const setBusinessDetailsCookie = (businessdata) => {
    writeCookie(COOKIES.BUSINESS_DETAILS, businessdata);
};

export const getBusinessDetailsCookie = () => readCookie(COOKIES.BUSINESS_DETAILS) || {};

export const clearBusinessDetailsCookie = () => {
    clearCookie(COOKIES.BUSINESS_DETAILS);
};

const storeItemsInSession = (sessionName, items) => {
    sessionStorage.setItem(sessionName, JSON.stringify(items));
}

const getItemByIdFromSession =(sessionName, itemId) => {
    const session = sessionStorage.getItem(sessionName);
    const items = session?JSON.parse(session): [];
    return items.find(itm => itm.id === itemId);
}

const updateItemInSession = (sessionName, item) =>{
    const session = sessionStorage.getItem(sessionName);
    const items = session?JSON.parse(session): [];
    items.forEach((itm,i) =>{
        if(itm.id === item.id){
            items[i] = item;
            sessionStorage.setItem(sessionName, JSON.stringify(items));
            return true;
        }
    });
    return false;
}
export const storeEventsInSession = (events) => {
    storeItemsInSession(SESSION_STORAGE.EVENTS, events);
};

export const storePMethodsInSession = (methods) => {
    storeItemsInSession(SESSION_STORAGE.P_METHODS, methods);
};
export const getPMethodsInSession = (methodid) => {
   return getItemByIdFromSession(SESSION_STORAGE.EVENTS, methodid);
}

export const getEventByIdFromSession = (eventId) => {
   return getItemByIdFromSession(SESSION_STORAGE.EVENTS, eventId);
}

export const updateEventInSession = (event) =>{
    return updateItemInSession(SESSION_STORAGE.EVENTS,event);
}

export const deleteEventsFromSession = () => {
    sessionStorage.removeItem(SESSION_STORAGE.EVENTS);
};

export const storeProductsInSession = (products) => {
    storeItemsInSession(SESSION_STORAGE.PRODUCTS, products);
};
export const getProductByIdFromSession = (productId) => {
    return getItemByIdFromSession(SESSION_STORAGE.PRODUCTS, productId);
}

export const updateProductInSession = (product) =>{
    return updateItemInSession(SESSION_STORAGE.PRODUCTS, product);
}

export const deleteProductsFromSession = () => {
    sessionStorage.removeItem(SESSION_STORAGE.PRODUCTS);
};

export const writeStorageItem = (name, value) => {
    localStorage.setItem(name, value)
}
export const readStorageItem = (name) => {
    return localStorage.getItem(name)
}